import type { ProductBundle } from "@wbly/data-storefront";
import { computed, atom } from "nanostores";
import { cartDetails } from "./details.store";

export const bundles = atom<ProductBundle[]>([]);

export const relevantBundle = computed(
  [cartDetails, bundles],
  (cartDetails, bundles) => {
    if (!cartDetails.data) {
      return null;
    }

    // The bundles slice doesn't exist for every locale.
    // So if it isn't populated in Prismic, we want to return early.
    if (!bundles) {
      return null;
    }

    const cartItemSkus = cartDetails.data.order.items.map(
      ({ solidus }) => solidus.productSku
    );

    // To match website-v2 behaviour, display only the first bundle that matches
    const relevantBundle = [...bundles].find(({ productIdsToShowOn }) =>
      productIdsToShowOn.find((id) => cartItemSkus?.includes(id))
    );

    if (relevantBundle) {
      // Exclude items already in our cart
      relevantBundle.productLinks = relevantBundle.productLinks?.filter(
        ({ sku }) =>
          !cartDetails.data.order.items.find(
            ({ solidus }) => solidus.productSku === sku
          )
      );

      return relevantBundle;
    }

    return null;
  }
);
